// The sentences LAMP offers in a message for the person to say next (#784): a Role change's nearest areas ("let
// Storekeeper add Items") and how to switch a Value Stream ("switch on Kaizen Loop"), each in “quotes”. Web chat
// shows each as a button that says it; Telegram shows the words as they are.

/** A quoted sentence LAMP offers: one that changes a Role or switches a Value Stream. */
const OFFERED = /“((?:let|switch on|switch off) [^”]+)”/gi;

/** The sentences `text` offers to say, each once, in the order said. */
export function suggestionsIn(text: string): string[] {
  return [...new Set([...text.matchAll(OFFERED)].map((m) => m[1] ?? "").filter((s) => s !== ""))];
}
